import script from "./RegionView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionView.vue?vue&type=script&setup=true&lang=js"

import "./RegionView.vue?vue&type=style&index=0&id=fdfaf41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdfaf41a"]])

export default __exports__